import { jsx } from "react/jsx-runtime";
const SvgChat2 = (props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx("path", { d: "M22 2H2.01L2 22L6 18H22V2ZM6 9H18V11H6V9ZM14 14H6V12H14V14ZM18 8H6V6H18V8Z", fill: "black" }) });
export default SvgChat2;
